import React from "react";
import { AssessmentStartPage } from "./AssessmentStartPage";
import { AssessmentRunner } from "./AssessmentRunner";
import { isB2C } from "../../libs/env";
export const Assessment = ({
  data,
  assessmentStarted,
  setAssessmentStarted,
  isReview,
  isStopTimer,
  setIsStopTimer,
  IsonRecorder,
  setIsonRecorder,
  timer,
  isOpenAdditionalResourceModal,
  setOpenAdditionalResourceModal,
  additionalResourceToggle,
  setSpeakingUrl,
  questions,
  currentPage,
  onblur,
  answers,
  resetAudio,
  setresetAudio,
  setCurrentPage,
  creatQuizDataAndSubmit,
  setShowTimeWarning,
  showTimeWarning,
  AssessmentStatusChangeCall,
  visualizerToggle,
  systemrequirementToggle,
  isSubmitting,
}) => {
  if (assessmentStarted) {
    AssessmentStatusChangeCall();
  }

  return assessmentStarted || data.status !== "New" ? (
    <AssessmentRunner
      isReview={isReview}
      data={data}
      IsonRecorder={IsonRecorder}
      setIsonRecorder= {setIsonRecorder}
      isStopTimer={isStopTimer}
      setIsStopTimer={setIsStopTimer}
      timer={timer}
      resetAudio={resetAudio}
      setresetAudio={setresetAudio}
      isOpenAdditionalResourceModal={isOpenAdditionalResourceModal}
      setOpenAdditionalResourceModal={setOpenAdditionalResourceModal}
      additionalResourceToggle={additionalResourceToggle}
      setSpeakingUrl={setSpeakingUrl}
      questions={questions}
      currentPage={currentPage}
      onblur={onblur}
      answers={answers}
      setCurrentPage={setCurrentPage}
      creatQuizDataAndSubmit={creatQuizDataAndSubmit}
      setShowTimeWarning={setShowTimeWarning}
      showTimeWarning={showTimeWarning}
      visualizerToggle={visualizerToggle}
      isSubmitting={isB2C.some(domain => window.location.origin.includes(domain)) ? isSubmitting : false}
    />
  ) : (
    <AssessmentStartPage
      data={data}
      setAssessmentStarted={setAssessmentStarted}
      systemrequirementToggle={systemrequirementToggle}
    />
  );
};
